import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { fallbackImage } from '../../../../images';
// Components
export var CardIconRH = function (_a) {
    var url = _a.url, bgClasses = _a.bgClasses, _b = _a.iconSize, iconSize = _b === void 0 ? '48px' : _b, _c = _a.title, title = _c === void 0 ? 'Benefit Icon' : _c;
    return (React.createElement("div", { className: "icon_container sui-max-w-[".concat(iconSize, "] sui-max-h-[").concat(iconSize, "] sui-flex sui-justify-center sui-items-center") },
        React.createElement("span", { className: "sui-text-center ".concat(bgClasses, " sui-w-[").concat(iconSize, "]") },
            React.createElement("img", { src: url, width: "".concat(iconSize), height: "".concat(iconSize), alt: title, onError: fallbackImage }))));
};
export var CardButtonRH = function (_a) {
    var label = _a.label, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, fullWidth = _a.fullWidth, url = _a.url, callback = _a.callback;
    return (React.createElement(Button, { variant: variant, disabled: false, href: url, fullWidth: fullWidth, onClick: callback }, label));
};
// Rows/Containers
export var CardRowContainerFullWidth = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "sui-grid sui-gap-0 sui-grid-cols-1 sm:sui-gap-12 sm:sui-mb-12" }, children));
};
export var CardRowContainerHalfWidth = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 sm:sui-gap-12 sm:sui-mb-12" }, children));
};
export var CardContainer = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "sui-border-t-1 sui-border-b-1 sui-border-solid sui-border-primary sm:sui-border-0" }, children));
};
